// extracted by mini-css-extract-plugin
export default {"socialLinks":"SocialLinks_socialLinks__Ib-CC","socialLink":"SocialLinks_socialLink__KtWs4","icon":"SocialLinks_icon__7IOOL"};